export default __webpack_public_path__ + "static/media/cheer.2086730c.jpg";